async function copyString(value: string) {
  return await navigator.clipboard.writeText(value)
}

export default copyString
